import axios from 'utils/axios';

export const updateTariffAdmin = (tariffId: string, name: string, price: number, active?: boolean) => {
  return axios.put(`/api/v1/tariffs/${tariffId}`, {
    active: active === true,
    name,
    price,
  });
};
